/**
 * Общие настройки для единого вида и поведения am4charts-графиков кабмуна
 */
import * as am4core from '@amcharts/amcharts4/core';
import { RoundedRectangle } from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { ColumnSeries } from '@amcharts/amcharts4/charts';
import { numberWithSpaces } from 'utils/numberWithSpaces';
import { XYSeries } from '@amcharts/amcharts4/.internal/charts/series/XYSeries';
import check from './assets/check.svg';

export const setupLegendBase = (disableToggle = false) => {
  const legend = new am4charts.Legend();

  legend.labels.template.fill = am4core.color('rgba(9, 21, 38, 0.6)');
  legend.labels.template.dx = 32;
  legend.useDefaultMarker = true;
  legend.itemContainers.template.paddingTop = 4;
  legend.itemContainers.template.paddingBottom = 4;

  if (disableToggle) {
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
  }

  return legend;
};

export const setupMarkerColumnBase = (marker: am4core.Container, drawCheckbox = false) => {
  const markerColumn = marker.children.getIndex(0) as RoundedRectangle;

  if (!markerColumn) {
    return;
  }

  markerColumn.width = 16;
  markerColumn.height = 16;
  markerColumn.dx = 32;
  markerColumn.dy = 3;
  markerColumn.cornerRadius(am4core.percent(100), am4core.percent(100), am4core.percent(100), am4core.percent(100));

  if (drawCheckbox) {
    // https://www.amcharts.com/docs/v4/tutorials/legend-markers-as-checkboxes/
    const markerColumnActiveState = markerColumn?.states.getKey('active');

    if (!markerColumnActiveState) {
      throw new Error();
    }

    markerColumnActiveState.properties.fillOpacity = 0.3;
    markerColumnActiveState.properties.fill = am4core.color('rgba(9, 21, 38, 0.07)');

    const rect = marker.createChild(am4core.RoundedRectangle);
    rect.width = 20;
    rect.height = 20;
    rect.verticalCenter = 'top';
    rect.horizontalCenter = 'left';
    rect.dy = 1;
    rect.strokeWidth = 0;
    rect.fill = am4core.color('rgba(9, 21, 38, 0.35)');
    rect.cornerRadius(5, 5, 5, 5);

    const checkbox = marker.createChild(am4core.Image);
    checkbox.width = 12;
    checkbox.height = 10;
    checkbox.verticalCenter = 'top';
    checkbox.horizontalCenter = 'left';

    checkbox.href = check;
    checkbox.dx = 4;
    checkbox.dy = 6;

    const checkboxActiveState = rect.states.create('active');
    checkboxActiveState.properties.opacity = 0.2;
  }

  return markerColumn;
};

export const setupCategoryAxisBase = (categoryAxis: am4charts.CategoryAxis) => {
  categoryAxis.renderer.grid.template.disabled = true;
  categoryAxis.renderer.minGridDistance = 30;
  categoryAxis.renderer.labels.template.fill = am4core.color('rgba(9, 21, 38, 0.6);');
};

export const setupValueAxisBase = (valueAxis: am4charts.ValueAxis) => {
  valueAxis.numberFormatter.numberFormat = '#';
  valueAxis.title.fill = am4core.color('#7D89A1');
  valueAxis.renderer.labels.template.fill = am4core.color('rgba(9, 21, 38, 0.6)');
  valueAxis.renderer.labels.template.adapter.add('textOutput', (text) => numberWithSpaces(+text));
};

export function setupSeriesTooltipBase(series: XYSeries) {
  if (!series.tooltip) {
    return;
  }

  series.tooltip.pointerOrientation = 'down';
  series.tooltip.getFillFromObject = false;
  series.tooltip.background.fill = am4core.color('#091526', 0.85);
  series.tooltip.background.cornerRadius = 8;

  series.tooltip.background.stroke = am4core.color('#091526', 0.85);

  if (series instanceof ColumnSeries) {
    series.columns.template.tooltipY = am4core.percent(0) as unknown as number;
  }
}

export const setupBaseChart = (chart: am4charts.XYChart) => {
  chart.fontSize = '14px';
  chart.maskBullets = false;
};
